export const mockTypeAudit = [
  { ID: 1, Title: 'Внутренний' },
  { ID: 2, Title: 'Перекрёстный' },
];

const getCurrentMonthPeriod = () => {
  const now = new Date();
  const period = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  return { startDate: period, endDate: period };
};

const defaultPeriod = getCurrentMonthPeriod();

export const initialFilter5SAudit = {
  created: {
    startDate: defaultPeriod.startDate,
    endDate: defaultPeriod.endDate,
  },
  location: { selected: [], selectedIds: [], search: '' },
  department: { selected: [], selectedIds: [], search: '' },
  site: { selected: [], selectedIds: [], search: '' },
  area: { selected: [], selectedIds: [], search: '' },
  typeAudit: { selected: [], selectedIds: [], search: '' },
  auditor: { selected: [], selectedIds: [], search: '' },
  coAuditor: { selected: [], selectedIds: [], search: '' },
};

export const filtersOpenFilter5SAudit = {
  created: false,
  location: false,
  department: false,
  site: false,
  area: false,
  typeAudit: false,
  auditor: false,
  coAuditor: false,
};

export const filterConfigFilter5SAudit = {
  created: {
    title: 'Месяц, год',
    hasSearch: false,
    monthYearOnly: true,
  },
  location: {
    title: 'Локация',
    hasSearch: false,
    searchPlaceholder: 'Поиск по локации',
    options: [],
  },
  department: {
    title: 'Отдел',
    hasSearch: false,
    searchPlaceholder: 'Поиск по отделу',
    options: [],
  },
  site: {
    title: 'Участок',
    hasSearch: true,
    searchPlaceholder: 'Поиск по участку',
    options: [],
  },
  area: {
    title: 'Зона',
    hasSearch: true,
    searchPlaceholder: 'Поиск по зоне',
    options: [],
  },
  typeAudit: {
    title: 'Тип аудита',
    hasSearch: false,
    searchPlaceholder: 'Поиск по типу аудита',
    options: mockTypeAudit.map((item) => item.Title),
  },
  auditor: {
    title: 'Аудитор',
    hasSearch: false,
    userSearch: true,
    options: [],
  },
  coAuditor: {
    title: 'Соаудитор',
    hasSearch: false,
    userSearch: true,
    options: [],
  },
};
